import axios from "axios";
import config from "./config";
const ApiService = {
  get(resource, params) {
    var path = `${config.API_URL}/${resource}`
    return axios.get(path, {
        params: params
      })
      .catch(error => {
        throw new Error(`${error}`);
      });
  }
};

export default ApiService;
